export const Projects = [
  {
    name: 'Melody',
    description: 'My team and I built Melody during a one week design sprint. It is an instrument rental app. Users are able to filter by instrument, create a new listing, see the geographic location of any listing, and book an instrument rental for a specified period of time. Melody is built using Ruby on Rails, Javascript, PostgreSQL, CSS, and HTML.',
    link: 'https://airbnb-meaagan.herokuapp.com/',
    login: 'username: meagan@email.com password: 123456'
  },
  {
    name: 'Rentie',
    description: 'My team and I built Rentie during a 2 week design sprint. It is built with Ruby on Rails, Javascript, PostgreSQL, Html, and CSS. It allows property owners to manage their daily tasks and contact list, track their finances, and add or delete a building or unit from their profile. The tenant side of the app allows tenants to submit maintenance requests directly to the property owner and pay their rent online using Stripe.',
    link: 'http://www.rentie.ca/users/sign_in',
    login: 'username: meagan@email.com password: 123456'
  }
];
